import PropTypes from "prop-types";
import Link from "next/link";
import dayjs from "dayjs";
import React, { useMemo, useState } from "react";

const RelatedPosts = (props) => {
  const postData = props?.data?.edges;
  const [email, setEmail] = useState("");
  const [emailErr, setEmailErr] = useState(false);
  const [subscribeSuccess, setSubscribeSuccess] = useState(false);

  const categoryNames = useMemo(() => {
    if (Array.isArray(props.categories) && props.categories.length > 0) {
      return new Set(props.categories);
    }
    if (props.category) {
      return new Set([props.category]);
    }
    return new Set();
  }, [props.categories, props.category]);

  const relatedEntries = useMemo(() => {
    if (!postData?.length || categoryNames.size === 0) {
      return [];
    }
    const selectedSlug = props.selectedBlog?.slug;
    const candidates = [];
    for (const __item of postData) {
      const cat = __item.node;
      if (!categoryNames.has(cat?.name)) continue;
      for (const node of cat.posts?.nodes || []) {
        if (node.slug === selectedSlug) continue;
        candidates.push({ post: node, category: cat });
      }
    }
    const seen = new Set();
    const unique = [];
    for (const c of candidates) {
      const s = c.post.slug;
      if (seen.has(s)) continue;
      seen.add(s);
      unique.push(c);
      if (unique.length >= 4) break;
    }
    return unique;
  }, [postData, categoryNames, props.selectedBlog?.slug]);

  const handleSubscribe = (e) => {
    e.preventDefault();
    const emailRegEx =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const isInvalid =
      email.length < 2 || !emailRegEx.test(String(email).toLowerCase());
    if (isInvalid) {
      setEmailErr(true);
      return;
    }
    setEmailErr(false);
    setSubscribeSuccess(true);
    setEmail("");
    setTimeout(() => setSubscribeSuccess(false), 3000);

    const xhr = new XMLHttpRequest();
    const url =
      "https://api.hsforms.com/submissions/v3/integration/submit/25310090/1d995a7c-cbe1-49aa-ae7c-0a94659c24ab";
    const data = {
      submittedAt: Date.now(),
      fields: [{ name: "email", value: email }],
      context: {
        pageUri:
          typeof window !== "undefined" ? window.location.href : "",
        pageName: props.selectedBlog?.title || "",
      },
    };
    xhr.open("POST", url);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.send(JSON.stringify(data));
  };

  if (!relatedEntries.length) return null;

  return (
    <div className="related-blog-v3">
      <div className="container">
        <h2>More articles based on your topic</h2>
        <div className="related-blog-v3-grid">
          <div className="related-articles">
            {relatedEntries.map(({ post: item__, category: item }, index__) => {
              let link = item__?.slug;
              if (
                item__?.parentSlug?.parentSlug != null &&
                item__?.parentSlug?.parentSlug.length > 0
              ) {
                link = `${item__?.parentSlug?.parentSlug}`;
              }
              return (
                <article
                  className="related-article-card"
                  key={item__.slug || index__}
                >
                  <Link
                    href={`/blog/category/${item.slug}/`}
                    prefetch={false}
                  >
                    <div className={`category ${item.slug}`}>{item.name}</div>
                  </Link>
                  <Link href={`/blog/${link}/`} itemProp="url" prefetch={false}>
                    <h4>{item__.title}</h4>
                  </Link>
                  <p className="related-article-date">
                    {dayjs(item__?.date).format("D MMM YYYY")}
                  </p>
                </article>
              );
            })}
          </div>

          <div className="related-subscribe-card">
            <img
              src="/images/blog/v2/subscribe-deco-1.svg"
              alt="Subscribe decoration"
              className="related-subscribe-deco deco-1"
              aria-hidden="true"
            />
            <img
              src="/images/blog/v2/subscribe-deco-2.svg"
              alt="Subscribe decoration"
              className="related-subscribe-deco deco-2"
              aria-hidden="true"
            />
            <h3>
              Subscribe to
              <br />
              get our latest
              <br />
              updates
            </h3>
            <form onSubmit={handleSubscribe}>
              <input
                type="email"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  if (emailErr) setEmailErr(false);
                }}
                placeholder="Enter your email address"
                className={emailErr ? "is-error" : ""}
              />
              <button type="submit">Subscribe</button>
            </form>
            {(emailErr || subscribeSuccess) && (
              <p className={subscribeSuccess ? "ok" : "err"}>
                {subscribeSuccess
                  ? "Thank you for subscribing!"
                  : "Please enter a valid email."}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

RelatedPosts.propTypes = {
  category: PropTypes.string,
  categories: PropTypes.arrayOf(PropTypes.string),
  selectedBlog: PropTypes.any,
  data: PropTypes.any,
};
export default RelatedPosts;
